import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled from 'styled-components'

export const DndList = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`

export const DropIndicator = styled.div`
  display: none;
  position: absolute;
  top: 0;
  height: 100%;
  background-color: ${COLORS.primary};
  opacity: 0.3;
  border-radius: ${RADII.item};
  pointer-events: none;
`
